import { render, staticRenderFns } from "./RoleRequests.vue?vue&type=template&id=401a05df"
import script from "./RoleRequests.vue?vue&type=script&lang=js"
export * from "./RoleRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports